import { render, staticRenderFns } from "./MisFacturas.vue?vue&type=template&id=b94c406e&scoped=true"
import script from "./MisFacturas.vue?vue&type=script&lang=js"
export * from "./MisFacturas.vue?vue&type=script&lang=js"
import style0 from "./MisFacturas.vue?vue&type=style&index=0&id=b94c406e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94c406e",
  null
  
)

export default component.exports